import { useEffect, useRef } from 'react';
import { AgreementCreateForm } from '@/forms/AgreementCreateForm';

export function AgreementCreatePage() {
  const h1Ref = useRef<HTMLHeadingElement | null>(null);
  useEffect(() => h1Ref.current?.focus(), []);
  return (
    <div>
      <header className="page-header">
        <h1 ref={h1Ref} tabIndex={-1}>
          Create agreement
        </h1>
      </header>
      <AgreementCreateForm />
    </div>
  );
}
